import React from 'react';
import { ContentElementCompanyLogos as CeCompanyLogos } from '@vgn-medien-holding/vgn-fe-components';
import { ContentElementCompanyLogos } from '@src/lib/graphql/generated';
import companyLogoStyle from '../ContentElementCompanyLogo/styles/default';
import defaultStyle from './styles/default';

export default function El(element: ContentElementCompanyLogos) {
  return <CeCompanyLogos element={element} classProps={defaultStyle} companyLogoClassProps={companyLogoStyle} />;
}
